ready(function () {

   // -- sticky menu --
  // -----------------

  let lastScroll = 0;
  const header = document.querySelector("header");
  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > lastScroll && currentScroll > header.offsetHeight) {
      header.classList.add("-translate-y-full");
    } else {
      header.classList.remove("-translate-y-full");
    }
    lastScroll = currentScroll;
  });



  // -- mobile menu --
  // ------------------

  const mainMenuBurgerBtn = document.getElementById("mainMenuBurgerBtn");
  const header__mainMenu = document.getElementById("header__mainMenu");
  const iconBurger = mainMenuBurgerBtn.querySelector(".icon-burger");
const iconClose = mainMenuBurgerBtn.querySelector(".icon-burger-close");

  mainMenuBurgerBtn.addEventListener('click', (e) => {
    if (mainMenuBurgerBtn.classList.contains("mainMenu--open")) {
      mainMenuBurgerBtn.classList.remove("mainMenu--open");
      header__mainMenu.classList.remove("mainMenu--open");
      document.body.classList.remove("overflow-hidden");
    
      // Switch icons
      iconBurger.classList.remove("hidden");
      iconBurger.classList.add("block");
      iconClose.classList.remove("block");
      iconClose.classList.add("hidden");
    } else {
      mainMenuBurgerBtn.classList.add("mainMenu--open");
      header__mainMenu.classList.add("mainMenu--open");
      document.body.classList.add("overflow-hidden");
    
      // Switch icons
      iconBurger.classList.remove("block");
      iconBurger.classList.add("hidden");
      iconClose.classList.remove("hidden");
      iconClose.classList.add("block");
    }
    
  });

  // -- reset open menu (mobile) --
  ['resize','orientationchange'].forEach(function(eventType){
    window.addEventListener(eventType, (e) => {
      mainMenuBurgerBtn.classList.remove("mainMenu--open");
      header__mainMenu.classList.remove("mainMenu--open");
      iconBurger.classList.remove("hidden");
iconBurger.classList.add("block");
iconClose.classList.remove("block");
iconClose.classList.add("hidden");

    });
  });


});